export default "<div class=\"bg-backup-alt\">\n  <div class=\"container\">\n    <ng-content></ng-content>\n  </div>\n</div>\n";